// TODO: 日文文案待产品确认，暂与中文设计稿保持一致
export default {
  breadcrumb: '面谈详情',
  title: '{name} 的面谈',
  aiInterview: 'AI 面谈',
  manualInterview: '人工面谈',
  tabs: {
    video: '面谈视频',
    result: '面谈结果',
    summary: '面谈纪要',
  },
  updater: '更新者',
  updateTime: '更新日時',
  download: '下载',
  reupload: '再アップロード',
  upload: '上传',
  uploadTip: '限 MP4/MKV/AVI 格式、单个文件需小于 1 GB。',
  videoProcessing: '動画をアップロードしました。処理中のため、しばらくしてから更新してください。',
  refresh: '更新',
  noVideo: '面談動画はまだありません',
  uploadSuccess: '上传成功',
  durationFormat: '{minutes}分{seconds}秒',
  empty: '暂无内容',
  uploadDialog: {
    title: '面談動画をアップロード',
    description: 'アップロード後、選択した以下の処理を自動で実行します：',
    generateResult: '面談結果を自動生成・更新',
    generateSummary: '面談記録を自動生成・更新',
  },
  result: {
    title: '面谈结果',
    updateFromVideo: '基于面谈视频更新',
    edit: '编辑面谈结果',
    uploadVideoFirst: '请先上传面谈视频',
    overwriteTitle: '基于面谈视频更新面谈结果',
    overwriteContent: '确认后将覆盖之前的面谈结果，确认是否继续？',
    continue: '继续',
    generating: '正在基于面谈视频生成…',
    jobCommunication: '职位沟通',
    agreeApply: '同意投递',
    notConsider: '暂不考虑',
    pending: '待确认意向',
    japanese: '日语能力',
    bc: 'BC 能力',
    score: '评分',
    strengths: '优势',
    suggestions: '改善建议',
    invalidJobId: '求人 ID 格式不正确：{ids}',
  },
  summary: {
    title: '面谈纪要',
    edit: '编辑面谈纪要',
    overwriteTitle: '基于面谈视频更新面谈纪要',
    overwriteContent: '确认后将覆盖之前的面谈纪要，确认是否继续？',
  },
  player: {
    switchTimeMode: '切换时间展示方式',
    backward: '后退 15 秒',
    forward: '前进 15 秒',
    play: '播放',
    pause: '暂停',
    subtitle: '字幕',
    fullscreen: '全屏',
    exitFullscreen: '退出全屏',
  },
}
